import NewsletterShow from "../components/newsletter/Show";

export default [
  { name: 'Newsletter', path: '/newsletter', component: NewsletterShow,  }
]
